<template>
  <div class="font-weight-bold">
    {{ message }}
  </div>
</template>
<script>
export default {
  constructor: () => {},
  name: "SellerWarning",
  props: {
    message: {
      type: String,
      default: () => "",
    },
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>
